'use strict';

module.exports = function isEdge(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('Edge/') !== -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/browser-detection/is-edge.js
// module id = 648
// module chunks = 0